import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { DeleteButton, EditLink } from "../_components/AdminRowActions";

const TemplateItem = ({ template, deleteTemplate, count }) => (
  <tr>
    <td className={cellClass}>{count + 1}</td>
    <td className={cellClass}>{template.templatename}</td>
    <td className={cellClass}>
      <AdminBadge tone={template.iscustomeremail ? "info" : "neutral"}>
        {template.iscustomeremail ? "Yes" : "No"}
      </AdminBadge>
    </td>
    <td className={stickyCellClass}>
      <AdminRowActions>
        <EditLink to={`/admin/templatelist/edit/${template._id}`} label="Edit template" />
        <DeleteButton
          label="Delete template"
          onClick={() => deleteTemplate(template._id)}
        />
      </AdminRowActions>
    </td>
  </tr>
);

export default TemplateItem;
